export const CLEAR_PROJECT = 'PROJECTS/CLEAR_PROJECT';

export interface IClearProject {
  type: typeof CLEAR_PROJECT;
}
